import React from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-regular-svg-icons'
import { faShareNodes } from '@fortawesome/free-solid-svg-icons'
import { UserProviderUserDto } from '~/modules/Auth/Infrastructure/Dtos/UserProviderUserDto'
import { ShareService } from '~/modules/UserGallery/ShareService'
import styles from './index.module.scss'

interface BannerProps {
  title: string
  url: string
  user: UserProviderUserDto
}

export const Banner: React.FC<BannerProps> = ({ title, url, user }) => {
  const { t } = useTranslation('user_gallery')
  const [shareService, setShareService] = React.useState<ShareService | undefined>()

  React.useEffect(() => {
    if (window !== undefined && shareService === undefined) {
      setShareService(new ShareService(window.navigator))
    }
  }, [shareService])

  let sinceField: React.ReactElement | null = null

  if (user.createdAt !== null) {
    sinceField = (
      <span className={ styles.banner__userSince }>
      <Trans
        i18nKey={ t('user_gallery_header_title') }
        values={ { date: user.createdAt } }
        components={ [
          <span className={ styles.banner__userCreatedAt } key={ user.name }>
          </span>,
        ] }
      />
    </span>
    )
  }

  let shareButton: React.ReactElement | null = null

  if (shareService && shareService.canShare()) {
    shareButton = (
      <button
        data-testid={ shareService.isShareApiAvailable() ? 'share-button' : 'copy-button' }
        className={ styles.banner__share }
        onClick={ () => shareService.share(title, url) }
      >
        <FontAwesomeIcon
          icon={ shareService.isShareApiAvailable() ? faShareNodes : faCopy }
          size="2x"
          title={ `${t(shareService.isShareApiAvailable() ? 'share_button_title' : 'copy_button_title')}` }
        />
      </button>
    )
  }

  return (
    <div className={ styles.banner__container }>
      <div className={ styles.banner__identity }>
        <img
          className={ styles.banner__avatar }
          src={ user.image ? user.image : '/img/defaults/user.png' }
          alt={ t('user_avatar_alt', { name: user.name }) }
        />

        <div className={ styles.banner__titleGroup }>
          { sinceField }

          <h1 className={ styles.banner__userName }>
            { user.name }
          </h1>
        </div>
      </div>

      { shareButton && (
        <div className={ styles.banner__actions }>
          { shareButton }
        </div>
      ) }
    </div>
  )
}
